module.exports = __webpack_public_path__ + "images/7343a94d7ee41935ae0923398b56dba13c7a15cf42502ed67dd80b3133f0583b.svg";